<div class="select-container">
  <div class="select-button" (click)="handleButtonClick($event)" [matMenuTriggerFor]="dropdownMenu"
    [matTooltip]="selectedOptionText | tooltip">
    <div class="button-text" [ngClass]="{'placeholder': !isOptionSelected, 'selected': isOptionSelected}">
      {{ selectedOptionText }}
    </div>
    <div class="button-icon">
      <img src="assets/icons/arrow_down_grey.svg">
    </div>
  </div>

  <mat-menu [class]="('select-list' | className: dropDownWidth)" #dropdownMenu="matMenu" xPosition="before"
    yPosition="below" (closed)="onMatMenuClosed()">

    <div class="container-header">
      <div class="header-title">Select Queue Names</div>
      <div class="columns-count">{{ queueCountText }}</div>
    </div>

    <div class="option-search-container">
      <input type="text" [(ngModel)]="searchQuery" placeholder="Search queues" (click)="stopPropagation($event)"
        class="custom-input">
    </div>

    <div class="queue-groups-container">
      <!-- Queue Groups -->
      <div class="queue-group" *ngFor="let group of filteredGroups">
        <div class="group-header" (click)="toggleGroupExpansion(group, $event)">
          <div class="group-checkbox">
            <input type="checkbox"
                   [checked]="group.isSelected"
                   (click)="onGroupCheckboxClick(group, $event)"
                   (change)="onGroupCheckboxChange(group, $event)">
          </div>
          <div class="group-name">{{ group.name }}</div>
          <div class="expand-icon">
            <img src="assets/icons/arrow_forward_grey.svg"
                 [class.rotated]="group.isExpanded">
          </div>
        </div>

        <!-- Individual Queues in Group (filtered by search when typing; auto-show when search has matches) -->
        <div class="queue-list" *ngIf="group.isExpanded || (searchQuery && getFilteredQueuesForGroup(group).length > 0)">
          <div class="queue-item" *ngFor="let queue of getFilteredQueuesForGroup(group)"
               (click)="onQueueSelect(getQueueOption(queue), $event)">
            <div class="queue-checkbox">
              <input type="checkbox"
                     [checked]="isQueueSelected(queue)"
                     (click)="onQueueCheckboxClick(getQueueOption(queue), $event)"
                     (change)="onQueueCheckboxChange(getQueueOption(queue), $event)">
            </div>
            <div class="queue-name">{{ queue }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="no-results" *ngIf="searchQuery && filteredGroups.length === 0 && filteredQueues.length === 0">
      No results found
    </div>
  </mat-menu>
</div>
